export default {
  apiKey: "AIzaSyBbCtDsh73bWtaSuQfBC-uD2kwSwNutviQ",
  authDomain: "nutnut-209512.firebaseapp.com",
  projectId: "nutnut-209512"
};


// WEBPACK FOOTER //
// ./src/firebaseConfig.ts